import { AccountAddress, Address } from '@melio/platform-api';

export const isAddress = (accountAddress: AccountAddress): accountAddress is Address =>
  !!accountAddress.line1 && !!accountAddress.city && !!accountAddress.state && !!accountAddress.postalCode;
